import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { MapPin, CheckCircle2 } from "lucide-react";
import {
  NA_PRIMARY,
  NA_SECONDARY,
  naCardBg,
  naCardBorder,
  naReadableText,
  naGradientLine,
} from "./naSectionTokens";

const chicagoPoints = [
  "Major airport and transit infrastructure",
  "Strong engineering and construction ecosystem",
  "Access to government and transportation agencies",
  "Excellent connectivity across the US and Canada",
  "Growing momentum around smart infrastructure and digital construction initiatives",
  "Central location that is highly accessible for decision-makers and industry leaders across North America",
];

function NAChicagoSection() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;

  return (
    <section className="section py-5" style={{ background: "transparent", position: "relative", zIndex: 1 }}>
      <Container>
        <Row className="justify-content-center mb-4">
          <Col lg={10} className="text-center text-lg-left">
            <h2
              className="mb-3"
              style={{
                fontSize: size ? "2.25rem" : "1.75rem",
                fontWeight: 700,
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                color: NA_SECONDARY,
                ...naReadableText,
              }}
            >
              Why Chicago?
            </h2>
            <div
              className="mx-auto ml-lg-0 mr-lg-0"
              style={{
                width: "100px",
                height: "4px",
                borderRadius: "2px",
                marginBottom: size ? "2rem" : "1.25rem",
                ...naGradientLine,
              }}
            />
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={10}>
            <Card
              style={{
                background: naCardBg,
                backdropFilter: "blur(12px)",
                border: naCardBorder,
                borderRadius: "20px",
                padding: size ? "2rem" : "1.5rem",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div className="d-flex align-items-start mb-4">
                <div
                  style={{
                    width: size ? 52 : 46,
                    height: size ? 52 : 46,
                    minWidth: size ? 52 : 46,
                    borderRadius: "14px",
                    background: `linear-gradient(145deg, ${NA_PRIMARY}33, ${NA_SECONDARY}22)`,
                    border: `2px solid ${NA_PRIMARY}55`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MapPin size={size ? 26 : 22} strokeWidth={2} style={{ color: NA_PRIMARY }} />
                </div>
                <div className="ml-3">
                  <p
                    className="mb-0"
                    style={{
                      fontSize: size ? "1.18rem" : "1.05rem",
                      lineHeight: 1.75,
                      fontWeight: 600,
                      ...naReadableText,
                    }}
                  >
                    Chicago is one of North America&apos;s most strategically important infrastructure
                    and transportation ecosystems.
                  </p>
                </div>
              </div>
              <p
                className="mb-3"
                style={{
                  fontSize: size ? "1.05rem" : "0.98rem",
                  fontWeight: 600,
                  color: NA_SECONDARY,
                  ...naReadableText,
                }}
              >
                The city offers:
              </p>
              <ul className="list-unstyled mb-0">
                {chicagoPoints.map((line, i) => (
                  <li key={i} className="d-flex mb-2" style={{ ...naReadableText }}>
                    <CheckCircle2
                      className="flex-shrink-0 mt-1"
                      size={18}
                      style={{ color: NA_PRIMARY, marginRight: "0.65rem" }}
                      strokeWidth={2.2}
                    />
                    <span style={{ fontSize: size ? "1.02rem" : "0.94rem", lineHeight: 1.65 }}>{line}</span>
                  </li>
                ))}
              </ul>
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  ...naGradientLine,
                  opacity: 0.85,
                }}
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default NAChicagoSection;
